import { render, staticRenderFns } from "./important.vue?vue&type=template&id=8f4ea272&"
import script from "./important.vue?vue&type=script&lang=ts&"
export * from "./important.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports